import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { INITIAL_MORE_FILTERS, type InstallationMoreFiltersType } from "./InstallationList/MoreFiltersTypes"
import type { InstallationParentStatus } from "./installationService"

interface InstallationListState {
    selectedParentStatus: InstallationParentStatus
    searchKey: string
    statusIds: number[]
    page: number
    perPage: number
    selectedTab: number
}

interface InstallationState {
    visibleColumns: { name: string; visible: boolean }[]
    moreFilters: InstallationMoreFiltersType
    installationListState: InstallationListState
}

const initialState: InstallationState = {
    visibleColumns: [
        { name: "Business POC", visible: false },
        { name: "TAT", visible: false },
    ],
    moreFilters: INITIAL_MORE_FILTERS,
    installationListState: {
        selectedParentStatus: "all_tab",
        searchKey: "",
        statusIds: [],
        page: 1,
        perPage: 10,
        selectedTab: 0,
    },
}

const InstallationSlice = createSlice({
    name: "Installation",
    initialState,
    reducers: {
        setInstallationVisibleColumns: (state, action: PayloadAction<{ name: string; visible: boolean }[]>) => {
            state.visibleColumns = action.payload
        },
        setInstallationMoreFilters: (state, action: PayloadAction<InstallationMoreFiltersType>) => {
            state.moreFilters = action.payload
        },
        setInstallationListParentStatus: (state, action: PayloadAction<InstallationParentStatus>) => {
            state.installationListState.selectedParentStatus = action.payload
        },
        setInstallationListSearchKey: (state, action: PayloadAction<string>) => {
            state.installationListState.searchKey = action.payload
        },
        setInstallationListStatusIds: (state, action: PayloadAction<number[]>) => {
            state.installationListState.statusIds = action.payload
        },
        setInstallationListPage: (state, action: PayloadAction<number>) => {
            state.installationListState.page = action.payload
        },
        setInstallationListPerPage: (state, action: PayloadAction<number>) => {
            state.installationListState.perPage = action.payload
        },
        setInstallationListSelectedTab: (state, action: PayloadAction<number>) => {
            state.installationListState.selectedTab = action.payload
        },
    },
})

export const {
    setInstallationVisibleColumns,
    setInstallationMoreFilters,
    setInstallationListParentStatus,
    setInstallationListSearchKey,
    setInstallationListStatusIds,
    setInstallationListPage,
    setInstallationListPerPage,
    setInstallationListSelectedTab,
} = InstallationSlice.actions

export default InstallationSlice.reducer
